import usePost from '../usePost';
import {IUser, IUserRegisterParams} from './useUser';
import useGet from '../useGet';
import {IQueryByIdParams} from '../../utils/HttpInstance';
import {ICollectionWorkProject, ICollectionWorkProjectSaveParams} from './useCollectionWorkProject';
import {IContest} from './useContest';
import {CollectionWorkProjectStatusConfig} from './useCollectionWorkProjectRecord';

export interface ISystemVarConfig {
  schoolNames: string[];
  isAllowedRegister: boolean;
}

export default class UseSystem {
  static query() {
    return useGet<void, ISystemVarConfig>('system/query', {});
  }

  static save() {
    return usePost<ISystemVarConfig, ISystemVarConfig>('system/save', {});
  }
}
